import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { API_BASE_URL, provideUnauthenticatedConfig } from '@mds/ngx-core';
import { ConfigResponse } from '../shared';
import { apiBaseUrlFactory } from '../shared/config/api-base-url.factory';

export function provideConfiguration(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: API_BASE_URL,
      useFactory: apiBaseUrlFactory,
    },
    provideUnauthenticatedConfig<ConfigResponse>(apiConfigUrlFactory()),
  ]);
}

export function apiConfigUrlFactory(): string {
  return `${apiBaseUrlFactory()}/internal/v1.0/config`;
}
